<div class="modal-body">
  <div class="d-flex flex-row">
    <i class="bi bi-plus-lg h3"></i>
    <h4 class="mx-1 h3 mb-0">
      {{
        (entity ? "WORKING_AREA.EDIT_VARIETY" : "WORKING_AREA.ADD_VARIETY")
          | translate
      }}
    </h4>
  </div>
  <div class="bg-primary w-100" style="height: 2px"></div>

  <div class="py-3">
    <div [formGroup]="infoForm!">
      <div class="d-flex flex-column mx-5">
        <div class="d-flex">
          <h5>{{ "WORKING_AREA.VARIETY_NAME" | translate }}</h5>
          <p
            class="mx-2 text-danger mb-0"
            *ngIf="varietyName?.invalid && varietyName?.touched"
          >
            {{ "REGISTER.REQUIRED" | translate }}
          </p>
        </div>
        <div>
          <input
            mdbValidate
            type="text"
            class="form-control"
            formControlName="varietyName"
          />
        </div>
      </div>
      <div class="d-flex flex-column my-3 mx-5">
        <div class="d-flex">
          <h5>{{ "WORKING_AREA.GENUS" | translate }}</h5>
          <p
            class="mx-2 text-danger mb-0"
            *ngIf="species?.invalid && species?.touched"
          >
            {{ "REGISTER.REQUIRED" | translate }}
          </p>
        </div>
        <div class="w-100">
          <ng-select
            class="w-100"
            formControlName="species"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option *ngFor="let specie of specieList" [value]="specie.value">
              {{ specie.label }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="d-flex flex-column mx-5 mt-3">
        <div class="d-flex">
          <h5>{{ "WORKING_AREA.SELECT_HYBRID" | translate }}</h5>
          <p
            class="mx-2 text-danger mb-0"
            *ngIf="hybrid?.invalid && hybrid?.touched"
          >
            {{ "REGISTER.REQUIRED" | translate }}
          </p>
        </div>
        <div class="w-100">
          <ng-select
            class="w-100"
            formControlName="hybrid"
            [clearable]="true"
            [searchable]="false"
          >
            <ng-option *ngFor="let specie of specieList" [value]="specie.value">
              {{ specie.label }}
            </ng-option>
          </ng-select>
        </div>
      </div>


      <div class="d-flex flex-column mx-5 mt-3">
        <div class="d-flex">
          <h5>{{ "WORKING_AREA.VARIETY_TYPE" | translate }}</h5>
          <p
            class="mx-2 text-danger mb-0"
            *ngIf="material?.invalid && material?.touched"
          >
            {{ "REGISTER.REQUIRED" | translate }}
          </p>
        </div>

        <div class="w-100 mb-5">
          <ng-select
            class="w-100"
            formControlName="material"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option *ngFor="let m of materials" [value]="m">
              {{ m?.categoryLang }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      
      <div class="d-flex flex-column mx-5" formArrayName="subcategories">
        <div
          class="d-flex flex-column"
          *ngFor="let sub of subcategories.controls; index as i"
        >
          <div class="d-flex mt-3">
            <h5>{{ sub.get("name")?.value }}</h5>
            <p
              class="mx-2 text-danger mb-0"
              *ngIf="hybrid?.invalid && hybrid?.touched"
            >
              {{ "REGISTER.REQUIRED" | translate }}
            </p>
          </div>
          <div class="w-100" [formGroupName]="i">
            <ng-select
              class="w-100"
              [clearable]="false"
              [searchable]="false"
              formControlName="value"
            >
              <ng-option
                *ngFor="let descriptor of category.subCategories[i].descriptors"
                [value]="descriptor.materialTypeDescriptorID"
              >
                {{ descriptor.descriptorLang }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column mx-5" *ngIf="showVariety">
        <div class="d-flex mt-3">
          <h5>{{ "WORKING_AREA.SELECT_VARIETIES" | translate }}</h5>
          <p
            class="mx-2 text-danger mb-0"
            *ngIf="varieties?.invalid && varieties?.touched"
          >
            {{ "REGISTER.REQUIRED" | translate }}
          </p>
        </div>
        <div class="w-100">
          <ng-select
            class="w-100"
            [multiple]="true"
            formControlName="varieties"
            [notFoundText]="'PLACEHOLDER.NOT_FOUND' | translate"
            [disabled]="showVariety"
          >
            <ng-option
              *ngFor="let variety of varietyList"
              [value]="variety.value"
            >
              {{ variety.label }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="d-flex flex-column mx-5" *ngIf="showVariety && showLocation">
        <h5 class="mx-auto my-4">
          {{ "WORKING_AREA.POPULATION_FORMED" | translate }}
        </h5>
        <div class="row gap-2">
          <div class="d-flex flex-column col">
            <div class="d-flex">
              <h5>{{ "WORKING_AREA.PROVINCE" | translate }}</h5>
              <p
                class="mx-2 text-danger mb-0"
                *ngIf="state?.invalid && state?.touched"
              >
                {{ "REGISTER.REQUIRED" | translate }}
              </p>
            </div>
            <div>
              <input
                mdbValidate
                type="text"
                class="form-control"
                formControlName="state"
                [disabled]="showLocation"
              />
            </div>
          </div>
          <div class="d-flex flex-column col">
            <div class="d-flex">
              <h5>{{ "WORKING_AREA.CITY" | translate }}</h5>
              <p
                class="mx-2 text-danger mb-0"
                *ngIf="city?.invalid && city?.touched"
              >
                {{ "REGISTER.REQUIRED" | translate }}
              </p>
            </div>
            <div>
              <input
                mdbValidate
                type="text"
                class="form-control"
                formControlName="city"
                [disabled]="showLocation"
              />
            </div>
          </div>
        </div>
        <div class="row mt-3 gap-2">
          <div class="d-flex flex-column col">
            <h5>{{ "WORKING_AREA.LATITUDE" | translate }}</h5>
            <div>
              <input
                mdbValidate
                type="text"
                class="form-control"
                formControlName="lat"
                [disabled]="showLocation"
              />
            </div>
          </div>
          <div class="d-flex flex-column col">
            <h5>{{ "WORKING_AREA.LONGITUDE" | translate }}</h5>
            <div>
              <input
                mdbValidate
                type="text"
                class="form-control"
                formControlName="lng"
                [disabled]="showLocation"
              />
            </div>
          </div>
          <div class="d-flex flex-column col">
            <h5>{{ "WORKING_AREA.ALTITUDE" | translate }}</h5>
            <div>
              <input
                mdbValidate
                type="text"
                class="form-control"
                formControlName="alt"
                [disabled]="showLocation"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modalRef.close()">
      {{ "BUTTONS.CLOSE" | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="addVariety()">
      {{ (entity ? "BUTTONS.EDIT" : "BUTTONS.ADD") | translate }}
    </button>
  </div>
</div>
